module.exports = __webpack_public_path__ + "img/icon_delete.aa49df85.svg";